export const PRODUCTION_DOMAIN = "chatca.st"
export const PRODUCTION_DOMAIN_JP = "chatcast.jp"
export const SUPPORT_MAIL_ADDRESS = "info@chatca.st"
export const GoogleAnalyticsTrackingId = "UA-68897793-1"
export const SlackPostUrl =
  "https://hooks.slack.com/services/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"
